import { dispatcher } from '../../../../helpers/projectHelper';
import { configuratorUnityObjectActions } from '../../../../redux/slicers/configurator/configuratorUnityObject.slicer';
import { configuratorBridge } from '../../../Configurator/unity/unityMethods';

export class UndoRedoConfiguratorTransformationPanel {
  constructor({ undoRedoInstance, unityContext }) {
    this.undoRedo = undoRedoInstance;
    this.unityContext = unityContext;
    this.init();
  }

  init = () => {
    this.changeConfiguratorTransformationPanel = this.undoRedo.createAction(
      ({ currentValue, prevValue }) => {
        const historyValue = {
          data: {
            currentValue,
            prevValue,
          },
          undo: () => {
            configuratorBridge.UpdateSelectedTransform(prevValue.unityData);
            dispatcher(
              configuratorUnityObjectActions.updateObjectTransform({
                id: prevValue.unityData.objectId,
                transformData: prevValue.reduxData,
              })
            );
          },
          redo: () => {
            configuratorBridge.UpdateSelectedTransform(currentValue.unityData);
            dispatcher(
              configuratorUnityObjectActions.updateObjectTransform({
                id: currentValue.unityData.objectId,
                transformData: currentValue.reduxData,
              })
            );
          },
        };
        return historyValue;
      }
    );
  };
}
